import i18n from '@/utils/i18n';
import React from 'react';
import { CloseButton } from '@/components/close-button';
import { SCREEN_PADDING, TYPOGRAPHY } from '@/styles';
import { StyleProp, StyleSheet, Text, View, ViewStyle } from 'react-native';
import { useLayoutContext } from '@/contexts/layout-context';

const CLOSE_BUTTON_HIT_SLOP = {
  bottom: 8,
  left: 8,
  right: 8,
  top: 8,
};

interface Props {
  centerTitle?: boolean;
  children: React.ReactNode;
  hideCloseButton?: boolean;
  onClose: () => void;
  operationName: string;
  style?: StyleProp<ViewStyle>;
}

export const ItemMenuOperationsContent: React.FC<Props> = ({
  centerTitle = false,
  children,
  hideCloseButton,
  onClose,
  operationName,
  style,
}) => {
  const { isSmallLayout } = useLayoutContext();
  const defaultHideCloseButton = !isSmallLayout;

  const shouldHideCloseButton = hideCloseButton ?? defaultHideCloseButton;

  return (
    <View style={[styles.content, style]}>
      {shouldHideCloseButton ? null : (
        <View style={styles.closeButtonContainer}>
          <CloseButton
            hitSlop={CLOSE_BUTTON_HIT_SLOP}
            onPress={onClose}
            style={styles.resetPadding}
            trackingData={{
              name: 'item_menu_operations.close_button',
              properties: {
                operationName,
              },
            }}
          />
        </View>
      )}
      <Text
        style={[
          TYPOGRAPHY.h2,
          styles.contentTitle,
          centerTitle ? styles.contentTitleCenter : null,
        ]}
      >
        {i18n.t(operationName)}
      </Text>
      {children}
    </View>
  );
};

const styles = StyleSheet.create({
  closeButtonContainer: {
    alignSelf: 'flex-start',
    marginBottom: 24,
  },
  content: {
    paddingHorizontal: SCREEN_PADDING,
  },
  contentTitle: {
    marginBottom: 16,
    textAlign: 'left',
  },
  contentTitleCenter: {
    textAlign: 'center',
  },
  resetPadding: {
    paddingHorizontal: 0,
  },
});
